import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-231723dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = { ref: "message" }
const _hoisted_3 = {
  class: "main-layout",
  style: {"overflow":"hidden"}
}
const _hoisted_4 = {
  class: "container",
  style: {"height":"100%"}
}
const _hoisted_5 = { class: "flex col" }
const _hoisted_6 = { class: "flex justify-between wrap" }
const _hoisted_7 = { class: "btn-row grow" }
const _hoisted_8 = { class: "flex grow" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"position":"absolute","margin-left":"50px","margin-top":"-10px"},
  width: "24",
  height: "24",
  src: "/ico/edit-picture.svg"
}, null, -1))
const _hoisted_10 = {
  style: {"object-fit":"cover","width":"100%","height":"100%","border-radius":"6px"},
  ref: "picture",
  src: "/ico/equipement.svg"
}
const _hoisted_11 = { class: "flex grow" }
const _hoisted_12 = {
  key: 0,
  class: "edit-btn"
}
const _hoisted_13 = { class: "bold" }
const _hoisted_14 = { class: "flex justify-center align-center no-mobile" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeInput = _resolveComponent("SeInput")!
  const _component_StockImagePicker = _resolveComponent("StockImagePicker")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_SeForm = _resolveComponent("SeForm")!
  const _component_NavHeader = _resolveComponent("NavHeader")!
  const _component_ReadonlyField = _resolveComponent("ReadonlyField")!
  const _component_SeImage = _resolveComponent("SeImage")!
  const _component_SeDropdownItem = _resolveComponent("SeDropdownItem")!
  const _component_SeDropdown = _resolveComponent("SeDropdown")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_StoreModuleTab = _resolveComponent("StoreModuleTab")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SeModal, {
      title: "Illustration",
      ref: "illustrationModal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SeInput, {
          value: _ctx.state.element!.name,
          inputChange: _ctx.onNameChange
        }, null, 8, ["value", "inputChange"]),
        _createVNode(_component_StockImagePicker, {
          select: _ctx.pickStockImageIllustration,
          ref: "stockImages"
        }, null, 8, ["select"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_SeButton, {
            icon: "ico/edit-picture.svg",
            onPress: _ctx.pickIllustration
          }, {
            default: _withCtx(() => [
              _createTextVNode("Pick file")
            ]),
            _: 1
          }, 8, ["onPress"]),
          _createVNode(_component_SeButton, { onPress: _ctx.closeIllustrationModal }, {
            default: _withCtx(() => [
              _createTextVNode("Close")
            ]),
            _: 1
          }, 8, ["onPress"])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_SeModal, {
      ref: "modal",
      title: "Informations"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, null, 512)
      ]),
      _: 1
    }, 512),
    _createVNode(_component_SeModal, {
      ref: "typeModal",
      title: _ctx.Lang.getI18N('edit')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SeForm, {
          ref: "typeForm",
          class: "flex col",
          style: {"width":"80vw","max-width":"400px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SeInput, {
              ref: "typeName",
              class: "grow",
              value: "",
              placeholder: _ctx.Lang.getI18N('name'),
              required: ""
            }, null, 8, ["placeholder"]),
            _createVNode(_component_SeButton, {
              class: "modal-valid w100",
              onPress: _ctx.createOrEditStoreType
            }, {
              default: _withCtx(() => [
                _createTextVNode("Ok")
              ]),
              _: 1
            }, 8, ["onPress"])
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["title"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_NavHeader, {
        backButton: "true",
        title: _ctx.state.element!.getName()
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_ReadonlyField, {
                  locked: _ctx.state.element!.originValue?.illustration_lock
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openIllustrationModal && _ctx.openIllustrationModal(...args))),
                      class: "img-container"
                    }, [
                      _hoisted_9,
                      _createElementVNode("img", _hoisted_10, null, 512)
                    ])
                  ]),
                  _: 1
                }, 8, ["locked"]),
                _createVNode(_component_ReadonlyField, {
                  class: "grow",
                  locked: _ctx.state.element!.originValue?.name_lock
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SeInput, {
                      class: "grow",
                      ref: "name",
                      inputChange: _ctx.onNameChange,
                      value: _ctx.state.element!.getName(),
                      modelValue: _ctx.state.element!.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.element!.name) = $event)),
                      placeholder: "Name"
                    }, null, 8, ["inputChange", "value", "modelValue"])
                  ]),
                  _: 1
                }, 8, ["locked"]),
                (!_ctx.state.creation)
                  ? (_openBlock(), _createBlock(_component_SeButton, {
                      key: 0,
                      onPress: _ctx.clone,
                      class: "no-pc",
                      ref: "cloneBtn",
                      icon: "ico/copy.svg"
                    }, null, 8, ["onPress"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_SeButton, {
                  onPress: _ctx.apply,
                  tooltip: _ctx.Lang.getI18N('save'),
                  class: "no-pc",
                  ref: "applyBtn",
                  icon: "ico/save.svg"
                }, null, 8, ["onPress", "tooltip"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_ReadonlyField, {
                  class: "grow",
                  locked: _ctx.state.element!.originValue?.type_lock
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SeDropdown, {
                      class: "grow",
                      titleFunc: (type) => type.name,
                      ref: "typeSelect",
                      modelValue: _ctx.state.selectedType,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.selectedType) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.types, (type) => {
                          return (_openBlock(), _createBlock(_component_SeDropdownItem, {
                            value: type,
                            key: type.ref?.id
                          }, {
                            tailing: _withCtx(() => [
                              (type.storeSide)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createVNode(_component_SeImage, {
                                      onClick: () => _ctx.openEditTaskTypeModal(type),
                                      maxWidth: 18,
                                      maxHeight: 18,
                                      src: "/ico/edit-blue.svg"
                                    }, null, 8, ["onClick"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128)),
                        _createVNode(_component_SeDropdownItem, {
                          displayTitle: false,
                          class: "noselect",
                          onClick: _ctx.openTypeModalCreation
                        }, {
                          heading: _withCtx(() => [
                            _createElementVNode("span", _hoisted_13, " + " + _toDisplayString(_ctx.Lang.getI18N("add")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }, 8, ["titleFunc", "modelValue"])
                  ]),
                  _: 1
                }, 8, ["locked"]),
                _createVNode(_component_ReadonlyField, {
                  class: "no-pc",
                  locked: _ctx.state.element!.originValue?.active_lock,
                  style: {"background-color":"white","border-radius":"16px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ToggleSwitch, {
                      defaultValue: _ctx.state.element!.getActive(),
                      modelValue: _ctx.state.element!.active,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.element!.active) = $event)),
                      auto: "true"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("active")), 1)
                      ]),
                      _: 1
                    }, 8, ["defaultValue", "modelValue"])
                  ]),
                  _: 1
                }, 8, ["locked"])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_ReadonlyField, {
                locked: _ctx.state.element!.originValue?.active_lock,
                style: {"background-color":"white","border-radius":"16px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ToggleSwitch, {
                    defaultValue: _ctx.state.element!.getActive(),
                    modelValue: _ctx.state.element!.active,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.element!.active) = $event)),
                    auto: "true"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("active")), 1)
                    ]),
                    _: 1
                  }, 8, ["defaultValue", "modelValue"])
                ]),
                _: 1
              }, 8, ["locked"]),
              (!_ctx.state.creation)
                ? (_openBlock(), _createBlock(_component_SeButton, {
                    key: 0,
                    onPress: _ctx.clone,
                    class: "no-mobile",
                    ref: "cloneBtn",
                    icon: "ico/copy.svg"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("duplicate")), 1)
                    ]),
                    _: 1
                  }, 8, ["onPress"]))
                : _createCommentVNode("", true),
              _createVNode(_component_SeButton, {
                onPress: _ctx.apply,
                class: "no-mobile",
                ref: "applyBtn",
                tooltip: _ctx.Lang.getI18N('save'),
                icon: "ico/save.svg"
              }, null, 8, ["onPress", "tooltip"])
            ])
          ])
        ]),
        _createVNode(_component_StoreModuleTab, {
          ref: "moduleTab",
          store: _ctx.state.store!,
          element: _ctx.state.element!
        }, null, 8, ["store", "element"])
      ])
    ])
  ], 64))
}